import { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import AthletePoll from "./pages/AthletePoll";
import VideoIntro from "./pages/VideoIntro";
import ProductPoll from "./pages/ProductPoll";
import TriviaCoco from "./pages/TriviaCoco";
import TriviaTommy from "./pages/TriviaTommy";

import CocoCloset from "./pages/CocoCloset";
import TommyCloset from "./pages/TommyCloset";

import Delray from "./pages/Delray";
import Rally from "./pages/Rally";

import ShopCTA from "./pages/ShopCTA";

import { useState } from 'react';
import styles from "./Global.module.css";
import { createContext } from 'react';

export const PollContext = createContext({});

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/intro-video":
        title = "";
        metaDescription = "";
        break;
      case "/who-best":
        title = "";
        metaDescription = "";
        break;
      case "/coco-trivia":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  const [selected, setSelected] = useState({});
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if ((typeof umami !== 'undefined')) 
      { 
        setInitialized(true) 
      } else {
        window.umami = undefined
      }
  }, []);

  useEffect(() => {
    if (initialized) {
      umami.track(props => ({ ...props, url: location.pathname + location.search, title: location.pathname + location.search }));
    }
  }, [initialized, location]);

  return (
    <PollContext.Provider value={{ selected, setSelected }}>

    <Routes>
      <Route path="/" element={<VideoIntro />} />
      {/* <Route path="/intro-video" element={<VideoIntro />} /> */}
      <Route path="/who-best" element={<AthletePoll />} />
      <Route path="/coco-trivia" element={<TriviaCoco />} />
      <Route path="/tommy-trivia" element={<TriviaTommy />} />

      <Route path="/coco-closet" element={<CocoCloset />} />
      <Route path="/tommy-closet" element={<TommyCloset />} />

      <Route path="/product-poll" element={<ProductPoll />} />
      <Route path="/shop-cta" element={<ShopCTA />} />
      <Route path="/delray" element={<Delray />} />
      <Route path="/rally" element={<Rally />} />

      {/* <Route path="/test" element={<Fortress />} /> */}

    </Routes>
{/* 
      { !(/Mobi/i.test(window.navigator.userAgent)) &&
        <div className={styles.topMessage}>
          <p> You might want to open this page on a mobile device for better viewing! </p>
        </div>
      } */}

    </PollContext.Provider>
  );
}
export default App;
